/**
 * 404 page rendered by the catch-all route in app.tsx.
 * Without this, unmatched URLs render an empty <main> with just nav/footer.
 */

import { FileQuestion } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { buttonClasses, cn } from '../components/ui'
import { usePageTitle } from '../hooks/use-page-title'

export default function NotFoundPage() {
	const { t } = useTranslation()
	usePageTitle(t('errors.notFound'))

	return (
		<div className="max-w-2xl mx-auto px-4 py-16">
			<div className="card-refined p-12 text-center">
				<FileQuestion size={48} className="mx-auto mb-4 opacity-30" />
				<h1 className="text-2xl font-semibold">{t('errors.notFound')}</h1>
				<p className="text-base-content/60 mt-2">{t('errors.notFoundDesc')}</p>
				<Link to="/" className={cn(buttonClasses(), 'mt-6 inline-flex')}>
					{t('nav.home')}
				</Link>
			</div>
		</div>
	)
}
